import type { Token } from './createToken';

export class Container {
  private dependencies = new Map<symbol, unknown>();

  register<T>(token: Token<T>, value: T): void {
    this.dependencies.set(token, value);
  }

  resolve<T>(token: Token<T>): T {
    if (!this.dependencies.has(token)) {
      const name = token.description ?? token.toString();
      throw new Error(
        `[travelata-frontend] Зависимость "${name}" не зарегистрирована в DI-контейнере. Вызови initLibrary() из хоста до использования библиотеки.`,
      );
    }
    return this.dependencies.get(token) as T;
  }

  has<T>(token: Token<T>): boolean {
    return this.dependencies.has(token);
  }

  reset(): void {
    this.dependencies.clear();
  }
}

const defaultContainer = new Container();

let activeContainerProvider: (() => Container | undefined) | null = null;

export function setActiveContainerProvider(provider: (() => Container | undefined) | null): void {
  activeContainerProvider = provider;
}

function getActiveContainer(): Container {
  return activeContainerProvider?.() ?? defaultContainer;
}

class ContainerFacade extends Container {
  override register<T>(token: Token<T>, value: T): void {
    getActiveContainer().register(token, value);
  }

  override resolve<T>(token: Token<T>): T {
    return getActiveContainer().resolve(token);
  }

  override has<T>(token: Token<T>): boolean {
    return getActiveContainer().has(token);
  }

  override reset(): void {
    getActiveContainer().reset();
  }
}

export const container = new ContainerFacade();
